module.exports = __webpack_public_path__ + "static/media/Clarity_Diamonds.9a7c2953.jpg";